import React from 'react';
import Login from "./pages/Login";
import './App.css';

function App() {
  return <Login />;
}

export default App;
